import { Button } from '@/components/ui/button';
import PlusIcon from '@/public/images/ic_plus_button.svg';
import Image from 'next/image';
import React from 'react';

function PlusButton({
  onClick,
  disabled,
}: {
  onClick: any;
  disabled?: boolean;
}) {
  return (
    <Button
      className={`w-6 h-6 relative p-0 bg-[#FF7395] rounded-none hover:bg-[#FF7395] ${disabled && 'bg-[#EEEEEE]'}`}
      onClick={onClick}
    >
      <Image src={PlusIcon} alt="plus" fill />
    </Button>
  );
}

export default PlusButton;
